import React from 'react';
import Section from '@atlaskit/menu/section';

import { defineMessage, useIntl } from '@atlassian/jira-intl';
import { fg } from '@atlassian/jira-feature-gating';
import { ViewBlueprintsTriggerButton } from '@jira/polaris__component-view-blueprints/src/ViewBlueprintsTriggerButton.tsx';
import { ViewBlueprintsButtonGuard } from '@jira/polaris__component-view-blueprints/src/ViewBlueprintsButtonGuard.tsx';

const preBuiltViews = defineMessage({
	id: 'navigation-apps-sidebar-nav4-sidebars-common-jpd-nav-views.create-view-menu.menu.pre-built-views',
	defaultMessage: 'Pre-built views',
	description: 'Dropdown option to open View Templates Gallery',
});

export const PrebuildViews = (): React.JSX.Element | null => {
	const { formatMessage } = useIntl();

	if (!fg('jpd-view-templates-sample-project')) {
		return null;
	}

	return (
		<ViewBlueprintsButtonGuard>
			<Section isList hasSeparator>
				<ViewBlueprintsTriggerButton label={formatMessage(preBuiltViews)} />
			</Section>
		</ViewBlueprintsButtonGuard>
	);
};
